import React from 'react'
import { useTranslation } from 'react-i18next'

const ShippingOne = () => {
    const { t } = useTranslation()
    return (
        <section className="tw-my-8 shipping" id="shipping">
            <div className="container container-lg">
                <div className="row gy-4">
                    <div className="col-xxl-3 col-sm-6">
                        <div className="gap-16 shipping-item flex-align rounded-16 bg-main-50 hover-bg-main-100 transition-2 h-100">
                            <span className="flex-shrink-0 w-56 h-56 text-white flex-center rounded-circle bg-main-600 text-32">
                                <i className="ph-fill ph-car-profile" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">{t('common.fastDelivery')}</h6>
                                <span className="text-sm text-heading">
                                    {t('common.fastDeliveryDescription')}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="gap-16 shipping-item flex-align rounded-16 bg-main-50 hover-bg-main-100 transition-2 h-100">
                            <span className="flex-shrink-0 w-56 h-56 text-white flex-center rounded-circle bg-main-600 text-32">
                                <i className="ph-fill ph-hand-heart" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">{t('common.localPickup')}</h6>
                                <span className="text-sm text-heading">
                                    {t('common.localPickupDescription')}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="gap-16 shipping-item flex-align rounded-16 bg-main-50 hover-bg-main-100 transition-2 h-100">
                            <span className="flex-shrink-0 w-56 h-56 text-white flex-center rounded-circle bg-main-600 text-32">
                                <i className="ph-fill ph-credit-card" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">{t('common.guaranteedSatisfaction')}</h6>
                                <span className="text-sm text-heading">
                                    {t('common.guaranteedSatisfactionDescription')}
                                </span>
                            </div>
                        </div>
                    </div>
                    <div className="col-xxl-3 col-sm-6">
                        <div className="gap-16 shipping-item flex-align rounded-16 bg-main-50 hover-bg-main-100 transition-2 h-100">
                            <span className="flex-shrink-0 w-56 h-56 text-white flex-center rounded-circle bg-main-600 text-32">
                                <i className="ph-fill ph-chats" />
                            </span>
                            <div className="">
                                <h6 className="mb-0">{t('common.securePayments')}</h6>
                                <span className="text-sm text-heading">
                                    {t('common.securePaymentsDescription')}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

    )
}

export default ShippingOne